import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';
import './RsLoaderHorizontal.theme.scss';

function RsLoaderHorizontal({ className }) {
  return (
    <div className={cn('rs-loader-horizontal', className)}>
      <div className="rs-loader-horizontal__loading-bar" />
      <div className="rs-loader-horizontal__loading-bar" />
      <div className="rs-loader-horizontal__loading-bar" />
    </div>
  );
}

RsLoaderHorizontal.propTypes = {
  className: PropTypes.string,
};

export default RsLoaderHorizontal;
